export default function outsideClickHandler(enable, parentIds, cb) {
  const clickBody = event => {
    const hasChildNode = parentIds.find(parentId => {
      const parentNode = document.getElementById(parentId);
      return parentNode && parentNode.contains(event.target);
    });
    if (hasChildNode) return "";
    document.body.removeEventListener("click", clickBody);
    document.body.removeEventListener("touchstart", clickBody);
    return cb(event);
  };
  return enable
    ? (document.body.removeEventListener("click", clickBody),
      document.body.removeEventListener("touchstart", clickBody))
    : (document.body.addEventListener("click", clickBody),
      document.body.addEventListener("touchstart", clickBody));
}
